export class GapViewModel
{
  ObjectId: number = 0;
  ObjectName: string = "";
  TimeGap: number = 0;
  Time: number = 0;
  TrackDist: number = 0;
  TrackPoint: number = 0;

  init(data?: any): void
  {
    if (data)
    {
      this.ObjectId = data["objectId"];
      this.ObjectName = data["objectName"];
      this.TimeGap = data["timeGap"];
      this.TrackDist = data["trackDist"]
      this.TrackPoint = data["trackPoint"];
      this.Time = data["time"];
    }
  }

  static fromJS(data: any): GapViewModel
  {
    let result = new GapViewModel();
    result.init(data);
    return result;
  }
}
